import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12" style={{ backgroundColor: 'var(--surface-dark)' }}>
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* Left: Logo & About */}
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <img
                  src="https://customer-assets.emergentagent.com/job_nova-playschool/artifacts/md7rpxfo_ChatGPT%20Image%20Jan%204%2C%202026%2C%2007_04_42%20PM.png"
                  alt="HR KinderNova Logo"
                  className="h-12 w-auto"
                />
                <div>
                  <h3 className="text-xl font-bold heading-playful text-white">HR KinderNova</h3>
                  <p className="text-sm text-gray-400">Since 1943 Legacy</p>
                </div>
              </div>
              <p className="text-gray-300">
                Rooted in the legacy of HR Hindu High School, educating since 1943.
              </p>
            </div>

            {/* Middle: Quick Links */}
            <div>
              <h4 className="text-lg font-bold heading-playful text-white mb-4">Quick Links</h4>
              <ul className="space-y-2">
                {[
                  { label: 'Home', href: '#home' },
                  { label: 'About Us', href: '#about' },
                  { label: 'Programs', href: '#programs' },
                  { label: 'Admissions', href: '#admissions' },
                  { label: 'Contact', href: '#contact' },
                ].map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' })}
                      className="text-gray-300 hover:text-white transition-colors"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right: Contact Info */}
            <div>
              <h4 className="text-lg font-bold heading-playful text-white mb-4">Contact Info</h4>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3 text-gray-300">
                  <MapPin className="h-5 w-5 mt-1 flex-shrink-0" style={{ color: 'var(--primary-blue)' }} />
                  <span>Near Gita Bhawan Park, Rampura Mohalla, Hisar, Haryana</span>
                </li>
                <li className="flex items-center space-x-3">
                  <Phone className="h-5 w-5 flex-shrink-0" style={{ color: 'var(--primary-green)' }} />
                  <a href="tel:9467954126" className="text-gray-300 hover:text-white transition-colors">
                    9467954126
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-700 pt-8 mt-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <p className="text-gray-400 text-sm">
                &copy; {currentYear} HR KinderNova. All rights reserved.
              </p>
              <p className="text-gray-400 text-sm">
                Now Enrolling for Session 2026-27
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;